var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 866,
    viewBox: "0 0 1440 866",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36 2.37343C161.167 -1.62657 544 27.4984 600 42.3734C664 59.373 660.4 111.673 600 124.873C539.6 138.073 489 143.373 461 148.873C442.721 152.464 395.4 183.073 459 201.873C522.6 220.673 1050.9 240.966 1303.5 280.373C1487 309 1735.5 500.873 1303.5 650.873C871.5 800.873 224.167 855.373 -45.5 863.873L-57.5 800L-104 462.5C271.5 476.833 1001.87 481.496 1097.5 459.5C1147.5 448 1146.5 386.5 1097.5 378C811.014 328.303 229 269.5 119 253.5C50 243.464 26.5 141.5 119 120.5L310.5 92.873C329 90.873 337.5 67.373 310.5 58.873C275.982 48.0062 65.6667 47.2064 -36 50.373V16.5V2.37343Z",
    fill: "#DFECFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-36 2.37343C161.167 -1.62657 544 27.4984 600 42.3734C664 59.373 660.4 111.673 600 124.873C539.6 138.073 489 143.373 461 148.873C442.721 152.464 395.4 183.073 459 201.873C522.6 220.673 1050.9 240.966 1303.5 280.373C1487 309 1735.5 500.873 1303.5 650.873C871.5 800.873 224.167 855.373 -45.5 863.873L-57.5 800L-104 462.5C271.5 476.833 1001.87 481.496 1097.5 459.5C1147.5 448 1146.5 386.5 1097.5 378C811.014 328.303 229 269.5 119 253.5C50 243.464 26.5 141.5 119 120.5L310.5 92.873C329 90.873 337.5 67.373 310.5 58.873C275.982 48.0062 65.6667 47.2064 -36 50.373V16.5V2.37343Z",
    fill: "url(#paint0_linear_345_13001)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-36 2.37343C161.167 -1.62657 544 27.4984 600 42.3734C664 59.373 660.4 111.673 600 124.873C539.6 138.073 489 143.373 461 148.873C442.721 152.464 395.4 183.073 459 201.873C522.6 220.673 1050.9 240.966 1303.5 280.373C1487 309 1735.5 500.873 1303.5 650.873C871.5 800.873 224.167 855.373 -45.5 863.873L-57.5 800L-104 462.5C271.5 476.833 1001.87 481.496 1097.5 459.5C1147.5 448 1146.5 386.5 1097.5 378C811.014 328.303 229 269.5 119 253.5C50 243.464 26.5 141.5 119 120.5L310.5 92.873C329 90.873 337.5 67.373 310.5 58.873C275.982 48.0062 65.6667 47.2064 -36 50.373V16.5V2.37343Z",
    fill: "url(#paint1_linear_345_13001)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-36 16.5V50.373C65.6667 47.2064 275.982 48.0062 310.5 58.873C337.5 67.373 329 90.873 310.5 92.873L119 120.5C26.5 141.5 50 243.464 119 253.5C229 269.5 811.014 328.303 1097.5 378C1146.5 386.5 1147.5 448 1097.5 459.5C1001.87 481.496 271.5 476.833 -104 462.5L-57.5 800M-36 16.5V2.37343C161.167 -1.62657 544 27.4984 600 42.3734C664 59.373 660.4 111.673 600 124.873C539.6 138.073 489 143.373 461 148.873C442.721 152.464 395.4 183.073 459 201.873C522.6 220.673 1050.9 240.966 1303.5 280.373C1487 309 1735.5 500.873 1303.5 650.873C871.5 800.873 224.167 855.373 -45.5 863.873L-57.5 800M-36 16.5C151.333 22.8333 533.8 39 565 53C604 70.5 600 100.5 565 112C530.667 115 454.2 121 423 121C384 121 230.73 140.893 186.5 148.873C147 156 133.31 216.201 186.5 229C346.5 267.5 1154.46 308.16 1244 320.5C1556 363.5 1486.5 531.5 1391 575.5C1105.54 707.02 282.718 813.833 -57.5 800",
    stroke: "#ACCBF9",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_13001",
    x1: 719.533,
    y1: 2,
    x2: 719.533,
    y2: 863.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACCBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_345_13001",
    x1: 719.533,
    y1: 1.99996,
    x2: 1543,
    y2: 206.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACCBF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiver);
export default __webpack_public_path__ + "static/media/river.6eb8ff090815eafd91c5a092cb9b92df.svg";
export { ForwardRef as ReactComponent };